/**
 *  Requests of authentication.<br>
 *  Highly inspired by http://chandrewz.github.io/blog/authentication-with-vue-router.<br>
 */
import { last } from 'lodash-es'
import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'
import router from '@/router'
import store from '@/store'
import storageKeysConstants from '../configuration/storageKeys.constants'

// authentication status
const isAuthenticated = () => {
  return !!getLocalToken()
}

// Save auth token
const saveToken = (response) => {
  localStorage.setItem(storageKeysConstants.TOKEN_EXPIRATION, response.data.expiredDate)
  localStorage.setItem(storageKeysConstants.TOKEN, response.data.token)
  clientHTTP.setHeader('Authorization', response.data.tokenType + ' ' + response.data.token)
}

// Get saved token
const getLocalToken = () => {
  return localStorage.getItem(storageKeysConstants.TOKEN)
}

// Get token expiration date
const getTokenExpirationDate = () => {
  return localStorage.getItem(storageKeysConstants.TOKEN_EXPIRATION)
}

// Set Authorization header
const setHeader = () => {
  clientHTTP.setHeader('Authorization', 'Bearer ' + getLocalToken())
}

// Sign in the application
const login = (application, login, password) => {
  return clientHTTP.post(
    getLinkHref(application, 'login'),
    { login, password },
    {},
    { defaultErrorMessage: false }
  )
}

// Sign out from the application
const logout = (redirect, noRouting = false) => {
  // Clear local storage
  localStorage.removeItem(storageKeysConstants.TOKEN)
  localStorage.removeItem(storageKeysConstants.TOKEN_EXPIRATION)
  // Clear http client
  clientHTTP.setHeader('Authorization', null)

  // Clear stores
  // Clear selections
  store.commit('setGatewaysSelection', [])
  store.commit('setEndDevicesSelection', [])
  // Clear selected fleet and cluster
  store.dispatch('saveSelectedFleetId', -1)
  store.dispatch('saveSelectedClusterId', -1)
  // Clear check fleets and clusters
  store.commit('setUserHasFleets', null)
  store.commit('setUserHasClusters', null)
  // Clear notification center
  store.commit('clearAllNotifications', null)
  // Clear last viewed lists on home page
  store.commit('resetLastViewedLists')

  if (noRouting) return

  // Redirect to login page
  if (redirect) {
    // Clean redirect url as sometime it can loop...
    const allRedirectUri = redirect.split('redirect=')
    const lastRedirect = last(allRedirectUri)
    if (lastRedirect) redirect = decodeURIComponent(lastRedirect)

    router.push({
      path: '/login',
      query: { redirect }
    })
  } else {
    router.push('/login')
  }
}

const forgotPassword = (application, email, url) => {
  return clientHTTP.post(
    getLinkHref(application, 'requestPassword') + '?' + clientHTTP.encodeParams({ email, url }),
    {}
  )
}

const resetPassword = (application, password, token) => {
  return clientHTTP.post(
    getLinkHref(application, 'resetPassword'),
    { password },
    { 'Authorization': 'Bearer ' + token }
  )
}

export default {
  isAuthenticated,
  saveToken,
  getLocalToken,
  getTokenExpirationDate,
  setHeader,
  login,
  logout,
  forgotPassword,
  resetPassword
}
